import { resolveCritterAssetsUrl } from "./assetPaths";
import { FLOOR_APPEARANCE_MODES, getFloorAppearanceOptions } from "./floorAppearanceOptions";

export const SCENE_HDRI_LIGHT_PATH = "/scene/hri-background/studio_small_08_1k.hdr";
export const SCENE_HDRI_DARK_PATH = "/scene/hri-background/ferndale_studio_03_1k.hdr";
export const SCENE_HDRI_PATH = SCENE_HDRI_LIGHT_PATH;

export function getSceneHdriPath(options = getFloorAppearanceOptions()) {
  return options?.mode === FLOOR_APPEARANCE_MODES.dark
    ? SCENE_HDRI_DARK_PATH
    : SCENE_HDRI_LIGHT_PATH;
}

export function getSceneHdriUrls(options = getFloorAppearanceOptions()) {
  return [resolveCritterAssetsUrl(getSceneHdriPath(options))];
}
